module.exports = __webpack_public_path__ + "img/5a8e4d6.jpeg";